import type { RouteObject } from 'react-router'
import { ROUTES } from '@/shared/routes'
import { DashboardPage } from './pages/DashboardPage'
import { DeepDivePage } from './pages/DeepDivePage'

/** Pages for signed-in users; the app wraps them in its shell. */
export const dashboardRoutes: RouteObject[] = [
  { path: ROUTES.HOME, element: <DashboardPage /> },
  { path: ROUTES.DEEP_DIVE, element: <DeepDivePage /> },
]
